import React, { useMemo, useState } from 'react'
import { ShopCheckoutSideBarResponse } from '../models'
import { ShopCartContext } from '../context/use-shop-cart-context'

interface ShopCartProviderProps {
  children: React.ReactNode
}

export const ShopCartProvider: React.FC<ShopCartProviderProps> = ({ children }) => {
  const [cartData, setCartData] = useState<ShopCheckoutSideBarResponse | null>(null)

  const emptyCart = (): void => setCartData(null)

  const contextValue = useMemo(
    () => ({
      cartData,
      setCartData,
      emptyCart,
    }),
    [cartData]
  )

  return <ShopCartContext.Provider value={contextValue}>{children}</ShopCartContext.Provider>
}
